(function(){"use strict";
/* ---- Shopify product state ---- */
var $=function(id){return document.getElementById(id)};
var dataEl=$('SovaProductData');
var product=null;
try{product=JSON.parse(dataEl&&dataEl.textContent?dataEl.textContent:'null')}catch(e){product=null}
var SOVA_SINGLE_PRICE=3799;var SOVA_BUNDLE_PAID_PRICE=2799;var SOVA_BUNDLE_TOTAL=5598;var SOVA_BUNDLE_DISCOUNT=5799;
var state={variant:null,color:null,mainStyle:'Standard',bundle:'Buy 2, Get 1 Free',qty:3,price:0,options:{},tierSelections:{},adding:false};
function money(cents){
  var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency}).format((Number(cents)||0)/100)}catch(e){return ((Number(cents)||0)/100).toFixed(2)}
}
/* Reference-only USD->GBP display. The store charges in USD; this is shown
   purely so UK visitors have a rough idea of cost, clearly labeled "approx."
   in the markup. It is NOT used anywhere in cart/checkout math. Update
   GBP_APPROX_RATE periodically to keep it in the right ballpark. */
var GBP_APPROX_RATE=0.74;
function moneyGBPApprox(usdCents){
  var gbpAmount=(Number(usdCents)||0)/100*GBP_APPROX_RATE;
  try{return '≈ '+new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(gbpAmount)}
  catch(e){return '≈ £'+gbpAmount.toFixed(2)}
}
function syncApproxPricing(){
  var priceApprox=$('priceApprox');if(priceApprox)priceApprox.textContent=moneyGBPApprox(SOVA_SINGLE_PRICE);
  document.querySelectorAll('[data-tier-approx-persale]').forEach(function(el){
    var q=Number(el.dataset.tierApproxPersale)||1;
    el.textContent=moneyGBPApprox(q===3?SOVA_BUNDLE_PAID_PRICE:SOVA_SINGLE_PRICE);
  });
  document.querySelectorAll('[data-tier-approx-total]').forEach(function(el){
    var q=Number(el.dataset.tierApproxTotal)||1;
    el.textContent=moneyGBPApprox(q===3?SOVA_BUNDLE_TOTAL:SOVA_SINGLE_PRICE)+' total';
  });
}
function esc(v){return String(v==null?'':v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;')}
function normalizedColor(value){
  var s=String(value==null?'':value).toLowerCase();
  if(s.indexOf('black')>-1) return 'black';
  if(s.indexOf('pink')>-1) return 'pink';
  if(s.indexOf('purple')>-1) return 'purple';
  if(s.indexOf('white')>-1) return 'white';
  return '';
}
function baseColorName(c){
  var n=normalizedColor(c); return n ? n.charAt(0).toUpperCase()+n.slice(1) : String(c||'');
}
function renderOptions(){
  /* The grouped picker below is the single source of truth for these variants. */
  renderMainVariantPicker();
}
function variantColor(v){
  var vals=(v&&v.options)||[];
  for(var i=0;i<vals.length;i++){var c=normalizedColor(vals[i]);if(c)return c;}
  return normalizedColor(v&&v.title||'');
}
function variantStyle(v){return /rubber|cord|band/i.test(String(v&&v.title||'')+' '+((v&&v.options)||[]).join(' '))?'Rubber':'Standard';}
function variantHasStock(v){
  if(!v)return false;
  var qty=Number(v.inventory_quantity);
  /* Shopify can expose `available:false` for a variant whose inventory is
     present at another location. For this storefront, positive inventory is
     the source of truth for the UI; Shopify checkout remains the final guard. */
  if(qty>0 || v.server_in_stock===true || v.available===true || String(v.inventory_policy||'')==='continue')return true;
  var domStock=$('stockStatus');
  if(domStock && Number(domStock.getAttribute('data-inventory-quantity')||0)>0)return true;
  return false;
}
function colorVariants(color){var c=normalizedColor(color);if(!product||!product.variants||!c)return [];return product.variants.filter(function(v){return variantColor(v)===c;});}
function variantForGroupedColor(color,style){
  var arr=colorVariants(color);if(!arr.length)return null;
  if(style){
    var want=style==='Rubber';
    var hit=arr.find(function(v){return variantStyle(v)===(want?'Rubber':'Standard')&&variantHasStock(v)})||
            arr.find(function(v){return variantStyle(v)===(want?'Rubber':'Standard')});
    if(hit)return hit;
  }
  return arr.find(function(v){return variantStyle(v)==='Standard'&&variantHasStock(v)})||
         arr.find(function(v){return variantStyle(v)==='Standard'})||
         arr.find(function(v){return variantHasStock(v)})||arr[0];
}
function colorImage(name){var v=variantForGroupedColor(name,'Standard')||variantForGroupedColor(name,'Rubber');var fi=v&&(v.featured_image||v.image),src=fi&&(fi.src||fi.url);return src||'';}
function colorHex(name){var n=String(name||'').toLowerCase();if(n.indexOf('black')>-1)return '#3a3a3f';if(n.indexOf('white')>-1)return '#E8E0D2';if(n.indexOf('purple')>-1)return '#B7A2E6';if(n.indexOf('pink')>-1)return '#E9A0B4';return '#d8d2ca';}
function availableColors(){var order=['black','pink','purple','white'],out=[];order.forEach(function(c){if(colorVariants(c).length)out.push(c)});return out;}
function styleLabel(c,style){var arr=colorVariants(c);var rubber=arr.some(function(v){return variantStyle(v)==='Rubber';});if(!rubber)return 'Standard';if(style!=='Rubber')return 'Standard';var titles=arr.filter(function(v){return variantStyle(v)==='Rubber';}).map(function(v){return String(v.title||'');}).join(' ');return /cord/i.test(titles)?'Rubber Cord':'Rubber Band';}
function bundleDefaultSelections(qty){var c=normalizedColor(state.color)||'black';var arr=[];for(var i=0;i<qty;i++)arr.push({color:c,style:state.mainStyle||'Standard'});return arr;}
state.bundleSelections=[];
function renderMainVariantPicker(){
  var grid=$('sovaColorGrid'),styles=$('sovaStylePicker');if(!grid)return;
  var colors=availableColors();grid.innerHTML='';
  colors.forEach(function(c){
    var v=variantForGroupedColor(c,'Standard')||variantForGroupedColor(c,'Rubber');
    var b=document.createElement('button');b.type='button';b.className='sova-color-swatch';b.dataset.color=c;b.setAttribute('aria-label','Choose '+baseColorName(c));
    var src=colorImage(c);b.innerHTML='<span class="sova-color-img">'+(src?'<img src="'+esc(src)+'" alt="">':'')+'</span><span>'+baseColorName(c)+'</span>';
    b.addEventListener('click',function(e){e.stopPropagation();state.color=c;var v=variantForGroupedColor(c,state.mainStyle||'Standard');if(v){setVariant(v,false);state.mainStyle=variantStyle(v);}renderMainVariantPicker();renderBundleSelections();});
    grid.appendChild(b);
  });
  grid.querySelectorAll('.sova-color-swatch').forEach(function(b){b.classList.toggle('active',b.dataset.color===state.color)});
  if(styles)styles.innerHTML='';
}
function setVariant(v,resetBundle){
  if(!v)return;state.variant=v;
  var opts=v.options||[];(product.options||[]).forEach(function(n,i){if(opts[i])state.options[n]=opts[i]});
  state.color=variantColor(v)||state.color||'black';state.mainStyle=variantStyle(v);
  document.querySelectorAll('.sova-color-swatch').forEach(function(x){x.classList.toggle('active',x.dataset.color===state.color)});
  var variantLabel=$('sovaSelectedVariantName');if(variantLabel)variantLabel.textContent=baseColorName(state.color)+(state.mainStyle==='Rubber'?' · '+styleLabel(state.color,'Rubber'):'');
  var fi=v.featured_image||v.image,variantImg=fi&&(fi.src||fi.url)||colorImage(state.color);if(variantImg&&mainImg){mainImg.src=variantImg;mainImg.removeAttribute('srcset');document.querySelectorAll('#productThumbs div').forEach(function(x){x.classList.remove('active')});}
  var base=SOVA_SINGLE_PRICE,cmp=Number(v.compare_at_price)||0;if($('priceNow'))$('priceNow').textContent=money(base);if($('priceWas')){$('priceWas').textContent=cmp>base?money(cmp):'';$('priceWas').style.display=cmp>base?'':'none';}if($('priceSale')){$('priceSale').textContent=cmp>base?'Save '+Math.round((1-base/cmp)*100)+'%':' ';$('priceSale').style.display=cmp>base?'':'none';}
  document.querySelectorAll('[data-tier-total]').forEach(function(el){var q=Number(el.dataset.tierTotal)||1;el.textContent=money(q===3?SOVA_BUNDLE_PAID_PRICE:SOVA_SINGLE_PRICE);});
  document.querySelectorAll('[data-tier-was]').forEach(function(el){el.textContent=money(SOVA_SINGLE_PRICE);});
  document.querySelectorAll('[data-tier-offer-total]').forEach(function(el){var q=Number(el.dataset.tierOfferTotal)||1;el.textContent='Total today: '+money(q===3?SOVA_BUNDLE_TOTAL:SOVA_SINGLE_PRICE);});
  /* Stock is intentionally hidden from the storefront. Shopify/CJ still controls actual inventory and checkout availability. */ var btn=$('addCart');if(btn){btn.disabled=false;btn.textContent='ADD TO CART';}
  if(resetBundle!==false){[1,3].forEach(function(q){state.tierSelections[q]=bundleDefaultSelections(q);});}
  renderBundleSelections();syncSticky();syncApproxPricing();
}
function renderBundleSelections(){
  if(!product||!product.variants)return;
  var tiers=document.querySelectorAll('.tier-selections');
  tiers.forEach(function(box){
    var qty=Number(box.dataset.tierSelections)||1;
    if(!state.tierSelections[qty]||state.tierSelections[qty].length!==qty){
      state.tierSelections[qty]=bundleDefaultSelections(qty);
    }
    var selections=state.tierSelections[qty];
    box.innerHTML='';

    /* 1 Set: use the same visual color + style selector as the reference store. */
    if(qty===1){
      var sel=selections[0]||{color:state.color||'black',style:state.mainStyle||'Standard'};
      var wrap=document.createElement('div');
      wrap.className='single-variation';
      var colorRow=document.createElement('div'); colorRow.className='single-variation-row';
      var colorLabel=document.createElement('div'); colorLabel.className='single-variation-label'; colorLabel.textContent='Color';
      var swatches=document.createElement('div'); swatches.className='single-color-swatches';
      availableColors().forEach(function(c){
        var v=variantForGroupedColor(c,'Standard')||variantForGroupedColor(c,'Rubber');
        var img=v&&(v.featured_image||v.image),src=img&&(img.src||img.url)||colorImage(c);
        var b=document.createElement('button'); b.type='button'; b.className='single-color-swatch'; b.dataset.color=c;
        b.setAttribute('aria-label','Choose '+baseColorName(c)); b.title=baseColorName(c);
        b.innerHTML=src?'<img src="'+esc(src)+'" alt="'+esc(baseColorName(c))+'">':'<span>'+esc(baseColorName(c))+'</span>';
        if(c===sel.color)b.classList.add('active');
        b.addEventListener('click',function(e){
          e.preventDefault();e.stopPropagation();
          var nextStyle=sel.style;
          var next=variantForGroupedColor(c,nextStyle)||variantForGroupedColor(c,'Standard');
          if(next){nextStyle=variantStyle(next);setVariant(next,false);}
          state.tierSelections[1]=[{color:c,style:nextStyle}];
          renderBundleSelections();syncSticky();
        });
        swatches.appendChild(b);
      });
      colorRow.appendChild(colorLabel); colorRow.appendChild(swatches); wrap.appendChild(colorRow);

      var styleRow=document.createElement('div'); styleRow.className='single-variation-row style-row';
      var styleLabelEl=document.createElement('div'); styleLabelEl.className='single-variation-label'; styleLabelEl.textContent='Style';
      var styles=document.createElement('div'); styles.className='single-style-options';
      var hasRubber=colorVariants(sel.color).some(function(v){return variantStyle(v)==='Rubber';});
      ['Standard'].concat(hasRubber?['Rubber']:[]).forEach(function(st){
        var b=document.createElement('button');b.type='button';b.className='single-style-btn';
        if((sel.style==='Rubber'?'Rubber':'Standard')===st)b.classList.add('active');
        b.textContent=st==='Rubber'?styleLabel(sel.color,'Rubber'):'Standard';
        b.addEventListener('click',function(e){
          e.preventDefault();e.stopPropagation();
          var v=variantForGroupedColor(sel.color,st);
          if(v)setVariant(v,false);
          state.tierSelections[1]=[{color:sel.color,style:st}];
          renderBundleSelections();syncSticky();
        });
        styles.appendChild(b);
      });
      styleRow.appendChild(styleLabelEl);styleRow.appendChild(styles);wrap.appendChild(styleRow);
      box.appendChild(wrap);
      return;
    }

    /* 3-set bundle: each pair gets its own color + Standard/Rubber selector. */
    for(var i=0;i<qty;i++){
      var sel=selections[i]||{color:state.color||'black',style:'Standard'};
      var row=document.createElement('div');row.className='bundle-choice';
      var v=variantForGroupedColor(sel.color,sel.style)||variantForGroupedColor(sel.color,'Standard');
      var img=v&&(v.featured_image||v.image),src=img&&(img.src||img.url)||colorImage(sel.color);
      var styles=colorVariants(sel.color).some(function(x){return variantStyle(x)==='Rubber';});
      row.innerHTML='<span class="bundle-choice-img">'+(src?'<img src="'+esc(src)+'" alt="">':'')+'</span>'+
        '<div class="bundle-choice-fields"><label>Color</label><select class="bundle-color-select" aria-label="Pair '+(i+1)+' color">'+
        availableColors().map(function(c){return '<option value="'+c+'" '+(c===sel.color?'selected':'')+'>'+baseColorName(c)+'</option>';}).join('')+
        '</select></div>'+
        '<div class="bundle-choice-fields"><label>Style</label><select class="bundle-style-select" aria-label="Pair '+(i+1)+' style">'+
        '<option value="Standard" '+(sel.style!=='Rubber'?'selected':'')+'>Standard</option>'+
        (styles?'<option value="Rubber" '+(sel.style==='Rubber'?'selected':'')+'>'+esc(styleLabel(sel.color,'Rubber'))+'</option>':'')+
        '</select></div>';
      (function(row,qty,i){
        row.querySelector('.bundle-color-select').addEventListener('change',function(e){
          e.stopPropagation();state.tierSelections[qty][i]={color:this.value,style:'Standard'};renderBundleSelections();syncSticky();
        });
        row.querySelector('.bundle-style-select').addEventListener('change',function(e){
          e.stopPropagation();state.tierSelections[qty][i]={color:state.tierSelections[qty][i].color,style:this.value};renderBundleSelections();syncSticky();
        });
      })(row,qty,i);
      box.appendChild(row);
    }
  });
}
function renderSwatches(){renderMainVariantPicker();}
function bundlePrice(){
  var qty=Number(state.qty)||1;
  if(qty===1)return SOVA_SINGLE_PRICE;
  if(qty===3)return SOVA_BUNDLE_TOTAL;
  var arr=state.tierSelections[qty]||bundleDefaultSelections(qty),total=0;
  for(var i=0;i<qty;i++){total+=SOVA_SINGLE_PRICE;}
  return total;
}
function bundleOfferTotal(){return bundlePrice();}
function syncSticky(){
  var total=bundleOfferTotal();
  $('stickySel').textContent=state.bundle+' · '+(state.color?baseColorName(state.color):'Default');
  $('stickyPrice').textContent=money(total);
  var stickyApprox=$('stickyApprox');if(stickyApprox)stickyApprox.textContent=moneyGBPApprox(total);
}

/* ---- product gallery ---- */

var main=$('productGalleryMain'),mainImg=main&&main.querySelector('.product-main-image');
document.querySelectorAll('#productThumbs [data-image]').forEach(function(t){t.addEventListener('click',function(){document.querySelectorAll('#productThumbs div').forEach(function(x){x.classList.remove('active')});t.classList.add('active');if(mainImg){mainImg.src=t.dataset.image;mainImg.removeAttribute('srcset');}})});
/* ---- bundle tiers ---- */
var TIER_NAME={1:'1 Set',3:'Buy 2, Get 1 Free'};
document.querySelectorAll('.tier').forEach(function(t){
  t.setAttribute('tabindex','0');
  t.addEventListener('click',function(e){
    if(e.target.closest('.sova-variant-card')||e.target.closest('.sova-color-swatch')||e.target.closest('.bundle-choice')||e.target.closest('select'))return;
    document.querySelectorAll('.tier').forEach(function(x){x.classList.remove('sel')});t.classList.add('sel');
    state.qty=Number(t.dataset.qty)||1;state.bundle=TIER_NAME[state.qty]||state.qty+' Sets';if(!state.tierSelections[state.qty]||state.tierSelections[state.qty].length!==state.qty)state.tierSelections[state.qty]=bundleDefaultSelections(state.qty);renderBundleSelections();syncSticky();
    var pr=document.querySelector('.price-row');if(pr){pr.classList.remove('bump');void pr.offsetWidth;pr.classList.add('bump');}
  });
});
/* ---- Shopify cart ---- */
function shopUrl(path){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  return root.replace(/\/$/,'')+'/'+String(path||'').replace(/^\//,'');
}
function cartRequest(url,opts){
  opts=opts||{};
  var headers=Object.assign({'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},opts.headers||{});
  return fetch(url,Object.assign({credentials:'same-origin',cache:'no-store',headers:headers},opts)).then(function(r){
    return r.text().then(function(txt){
      var d={};try{d=txt?JSON.parse(txt):{}}catch(e){}
      if(!r.ok){
        var msg=d.description||d.message||('Cart request failed ('+r.status+')');
        var err=new Error(msg);err.status=r.status;throw err;
      }
      return d;
    });
  });
}
function getCart(){
  return fetch(shopUrl('/cart.js?_sova='+Date.now()),{method:'GET',credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){if(!r.ok)throw new Error('Could not load cart');return r.json();});
}
function renderCart(c){
  var box=$('cartItems');if(!box)return;
  var items=c.items||[];
  if(!items.length){box.innerHTML='<div class="empty">Your cart is empty.</div>';}
  else{
    box.innerHTML=items.map(function(it){
      var props=it.properties||{},slot=Number(props._sova_bundle_slot||0),isBundle=slot>0&&String(props._sova_bundle_offer||'')==='buy2get1';
      var displayPrice=isBundle?(slot===3?0:SOVA_BUNDLE_PAID_PRICE):Number(it.final_line_price||0);
      var priceLabel=isBundle?(slot===3?'FREE':money(SOVA_BUNDLE_PAID_PRICE)):money(displayPrice);
      var qtyControls=isBundle?'<div class="qty bundle-fixed"><span>1</span></div>':'<div class="qty"><button data-a="dec" data-key="'+esc(it.key)+'">−</button><span>'+it.quantity+'</span><button data-a="inc" data-key="'+esc(it.key)+'">+</button></div>';
      var badge=isBundle?'<span class="bundle-line-badge">'+(slot===3?'FREE — Buy 2, Get 1 Free':'Buy 2, Get 1 Free')+'</span>':'';
      return '<div class="citem '+(isBundle?'bundle-item bundle-slot-'+slot:'')+'"><div class="thumb">'+(it.image?'<img src="'+esc(it.image)+'" alt="'+esc(it.product_title||it.title)+'">':'')+'</div><div class="meta"><div class="n">'+esc(it.product_title||it.title)+'</div><div class="v">'+esc(it.variant_title||'')+'</div>'+badge+qtyControls+'<br><span class="rm" data-a="rm" data-key="'+esc(it.key)+'">Remove</span></div><div class="price '+(slot===3?'free-price':'')+'">'+priceLabel+'</div></div>';
    }).join('');
  }
  var hasBundle=items.some(function(it){var p=it.properties||{};return String(p._sova_bundle_offer||'')==='buy2get1';});
  var bundleItems=items.filter(function(it){var p=it.properties||{};return String(p._sova_bundle_offer||'')==='buy2get1';});
  var validBundle=hasBundle&&bundleItems.length>=3;
  var displaySubtotal=validBundle?SOVA_BUNDLE_TOTAL:Number(c.total_price||0);
  var sub=$('cartSubtotal');if(sub)sub.textContent=money(displaySubtotal);
  var count=$('cartCount');if(count)count.textContent=c.item_count||0;
  var checkoutTotal=$('checkoutTotal');if(checkoutTotal)checkoutTotal.textContent=money(displaySubtotal);
  var bundleSummary=$('bundleSummary');if(bundleSummary)bundleSummary.hidden=!validBundle;
  var bundleTotal=$('bundleSummaryTotal');if(bundleTotal)bundleTotal.textContent=money(SOVA_BUNDLE_TOTAL);
  var progressBar=$('drawerProgressBar'),progressAmount=$('drawerProgressAmount'),progressText=$('drawerProgressText');
  if(progressBar&&progressAmount&&progressText){
    var target=2500,progress=Math.min(100,Math.round((displaySubtotal/target)*100));
    progressBar.style.width=progress+'%';
    progressAmount.textContent=displaySubtotal>=target?'Unlocked':money(Math.max(0,target-displaySubtotal))+' to go';
    progressText.textContent=displaySubtotal>=target?'Free UK shipping unlocked':'Free UK shipping over $25';
  }
}
function refreshCart(){
  return getCart().then(function(c){window.__sovaCartItems=c.items||[];renderCart(c);return c;});
}
if($('cartItems'))$('cartItems').addEventListener('click',function(e){
  var b=e.target.closest('[data-a]');if(!b)return;
  var a=b.dataset.a,key=b.dataset.key,item=(window.__sovaCartItems||[]).find(function(x){return x.key===key});
  if(!item)return;
  var qty=a==='inc'?item.quantity+1:a==='dec'?Math.max(1,item.quantity-1):0;
  cartRequest(shopUrl('/cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(c){window.__sovaCartItems=c.items||[];renderCart(c);})
    .catch(function(err){toast(err.message||'Could not update cart');});
});
function openDrawer(){
  $('scrim').classList.add('open');$('drawer').classList.add('open');
  refreshCart().catch(function(){renderCart({items:[],item_count:0,total_price:0});});
}
function closeDrawer(){$('scrim').classList.remove('open');$('drawer').classList.remove('open');}
if($('cartBtn'))$('cartBtn').addEventListener('click',openDrawer);
if($('drawerClose'))$('drawerClose').addEventListener('click',closeDrawer);
if($('scrim'))$('scrim').addEventListener('click',closeDrawer);
if($('continueShop'))$('continueShop').addEventListener('click',closeDrawer);
function getRewardCode(){try{return (localStorage.getItem('sova_reward_code')||'').trim();}catch(e){return ''}}
function getBundleCodes(){var cfg=document.getElementById('SovaScratchConfig');var raw=cfg&&cfg.dataset.bundleDiscount?cfg.dataset.bundleDiscount.trim():'SOVA-B2G1,SOVA-BUNDLE-26';return raw.split(',').map(function(x){return x.trim();}).filter(Boolean);} function getBundleCode(){return getBundleCodes()[0]||'SOVA-B2G1';}
function discountCodesForCart(){var list=[],bundles=getBundleCodes(),reward=getRewardCode(),hasBundle=(window.__sovaCartItems||[]).some(function(it){var p=it.properties||{};return String(p._sova_bundle_offer||'')==='buy2get1';});if(hasBundle)bundles.forEach(function(code){if(code)list.push(code);});if(reward&&bundles.every(function(code){return reward.toUpperCase()!==String(code).toUpperCase();}))list.push(reward);return list;}
/* Shopify applies discount codes reliably through /discount/CODE rather than
   through cart/update.js. We use the discount route and return to the cart. */
function applyCartDiscounts(codes,redirectPath){
  codes=(codes||[]).filter(Boolean);
  if(!codes.length)return Promise.resolve(null);
  var joined=codes.map(function(x){return encodeURIComponent(x);}).join(',');
  var target=redirectPath||'/cart';
  window.location.href=shopUrl('/discount/'+joined+'?redirect='+encodeURIComponent(target));
  return new Promise(function(){ });
}
function checkoutWithDiscounts(){
  var codes=discountCodesForCart();
  var items=window.__sovaCartItems||[];
  /* IMPORTANT: send the customer through Shopify's /discount route first.
     This stores the discount in the Shopify session/cart, then opens the
     native checkout. The previous cart-permalink implementation could rebuild
     the cart as a single quantity line and leave the checkout at full price. */
  if(items.length && codes.length){
    var joined=codes.map(function(x){return encodeURIComponent(x);}).join(',');
    window.location.href=shopUrl('/discount/'+joined+'?redirect='+encodeURIComponent('/checkout'));
  }else if(codes.length){
    var joined2=codes.map(function(x){return encodeURIComponent(x);}).join(',');
    window.location.href=shopUrl('/discount/'+joined2+'?redirect='+encodeURIComponent('/checkout'));
  }else{
    window.location.href=shopUrl('/checkout');
  }
}
if($('checkoutBtn'))$('checkoutBtn').addEventListener('click',checkoutWithDiscounts);
if($('applyDrawerDiscount'))$('applyDrawerDiscount').addEventListener('click',function(){
  var i=$('drawerDiscount');if(!i||!i.value.trim())return;
  var reward=i.value.trim();
  try{localStorage.setItem('sova_reward_code',reward);}catch(e){}
  var codes=discountCodesForCart();
  var joined=codes.map(function(x){return encodeURIComponent(x);}).join(',');
  window.location.href=shopUrl('/discount/'+joined+'?redirect=/cart');
});
if($('drawerDiscount'))$('drawerDiscount').addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();$('applyDrawerDiscount').click();}});
var toastT;function toast(msg){var tm=$('toastMsg'),tt=$('toast');if(tm)tm.textContent=msg||'Added to cart';if(tt)tt.classList.add('show');clearTimeout(toastT);toastT=setTimeout(function(){if(tt)tt.classList.remove('show');},2200);}

/* Shopify cart add. Use the documented JSON `items` payload first so the
   whole bundle is added in one request. If Shopify rejects the AJAX request,
   fall back to a native Shopify cart permalink. This is especially useful on
   themes where a custom AJAX cart is more fragile than Shopify's cart route. */
function addVariantsToCart(items){
  return cartRequest(shopUrl('/cart/add.js'),{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:items.map(function(x){
      var out={id:Number(x.id),quantity:Number(x.quantity||1)};
      if(x.properties)out.properties=x.properties;
      return out;
    })})
  });
}
function buildCartPermalink(items,discount){
  var parts=items.map(function(x){return encodeURIComponent(String(x.id))+':'+encodeURIComponent(String(x.quantity||1));}).join(',');
  var q='storefront=true';
  if(discount)q+='&discount='+encodeURIComponent(discount);
  return shopUrl('/cart/'+parts+'?'+q);
}
function directCartFallback(items,discount){
  window.location.href=buildCartPermalink(items,discount);
}
function addToCart(){
  if(state.adding)return;
  state.adding=true;
  var qty=Math.max(1,Number(state.qty||1));
  var selections=state.tierSelections[qty]&&state.tierSelections[qty].length===qty?state.tierSelections[qty]:bundleDefaultSelections(qty);
  var items=selections.map(function(sel,index){
    var v=variantForGroupedColor(sel.color,sel.style)||variantForGroupedColor(sel.color,'Standard');
    if(!v||!v.id)return null;
    var item={id:Number(v.id),quantity:1};
    if(qty===3){item.properties={'_sova_bundle_offer':'buy2get1','_sova_bundle_slot':String(index+1)};}
    return item;
  }).filter(Boolean);
  if(items.length!==qty){state.adding=false;toast('Please choose a valid color and style for every pair.');return;}
  var btn=$('addCart');if(btn){btn.disabled=true;btn.textContent='ADDING…';}
  addVariantsToCart(items)
    .then(function(c){
      if(!c||!c.items||!c.items.length)throw new Error('Shopify did not add the selected variant.');
      return refreshCart();
    })
    .then(function(c){
      if(!c||!c.items||!c.items.length)throw new Error('Shopify did not add the selected variant.');
      /* Buy 2, Get 1 Free: keep the customer on the product page and open the
         AJAX cart drawer. The three bundle lines are tagged with properties so
         the drawer can display two paid pairs at $27.99 and one FREE pair.
         The actual Shopify discount code is applied when the customer checks out. */
      toast(qty===3?'Buy 2, Get 1 Free added to cart':'Added to cart');
      openDrawer();
    })
    .catch(function(err){
      if(err&&err.status){
        directCartFallback(items,qty===3?getBundleCodes().join(','):'');
      }else{
        toast(err.message||'Could not add to cart');
        openDrawer();
      }
    })
    .finally(function(){state.adding=false;if(btn){btn.disabled=false;btn.textContent='ADD TO CART';}});
}
if($('addCart'))$('addCart').addEventListener('click',addToCart);
if($('stickyAdd'))$('stickyAdd').addEventListener('click',addToCart);

/* ---- sticky bar ---- */
var buyBox=document.querySelector('.buy');window.addEventListener('scroll',function(){if(!buyBox)return;var r=buyBox.getBoundingClientRect();if(r.bottom<80)$('stickyBar').classList.add('show');else $('stickyBar').classList.remove('show');},{passive:true});
/* initialize product */
if(product&&Array.isArray(product.variants)&&product.variants.length){var initial=product.selected_or_first_available_variant||product.variants.find(function(v){return variantHasStock(v)})||product.variants[0];setVariant(initial,true);state.qty=3;state.bundle=TIER_NAME[3];var selectedTier=document.querySelector('.tier.sel');if(selectedTier)selectedTier.classList.add('sel');renderMainVariantPicker();renderBundleSelections();syncSticky();syncApproxPricing();}else{var ab=$('addCart');if(ab)ab.disabled=true;var ph=$('sovaColorGrid');if(ph)ph.innerHTML='<span style="font-size:12px;color:#777">Select a product in the theme editor.</span>';syncSticky();syncApproxPricing();}
refreshCart().then(function(c){window.__sovaCartItems=c.items||[]}).catch(function(){});

/* ---- video carousel ---- */
var vt=$('vtrack');
if(vt){
  var scrollByAmt=function(){return vt.querySelector('.vcard').offsetWidth+16;};
  var pn=$('vNext'),pv=$('vPrev'),bar=$('vBar');
  if(pn)pn.addEventListener('click',function(){vt.scrollBy({left:scrollByAmt(),behavior:'smooth'});});
  if(pv)pv.addEventListener('click',function(){vt.scrollBy({left:-scrollByAmt(),behavior:'smooth'});});
  function prog(){var max=vt.scrollWidth-vt.clientWidth;var pct=max>0?(vt.scrollLeft/max):0;if(bar)bar.style.width=(20+pct*80)+'%';}
  vt.addEventListener('scroll',prog,{passive:true});prog();

  /* silent hover preview on cards */
  vt.querySelectorAll('.vcard').forEach(function(c){
    var v=c.querySelector('video.thumb');
    c.addEventListener('mouseenter',function(){if(v){v.currentTime=0;var p=v.play();if(p&&p.catch)p.catch(function(){});}});
    c.addEventListener('mouseleave',function(){if(v){v.pause();v.currentTime=0;}});
  });

  /* fullscreen player */
  var VP=$('vplayer'),VV=$('vpVideo'),VA=$('vpAuthor'),VC=$('vpCap'),VM=$('vpMute'),VPB=$('vpProgress');
  var cards=Array.prototype.slice.call(vt.querySelectorAll('.vcard'));
  var idx=0,muted=false,rafId=null,openScrollY=0;
  function buildProgress(){VPB.innerHTML='';for(var i=0;i<cards.length;i++){var s=document.createElement('div');s.className='seg';s.innerHTML='<i></i>';VPB.appendChild(s);}}
  function paintProgress(){var segs=VPB.querySelectorAll('.seg');segs.forEach(function(s,i){if(i<idx)s.classList.add('done');else s.classList.remove('done');if(i===idx&&VV.duration){s.querySelector('i').style.width=((VV.currentTime/VV.duration)*100)+'%';}else if(i!==idx){s.querySelector('i').style.width=i<idx?'100%':'0%';}});rafId=requestAnimationFrame(paintProgress);}
  function loadIdx(i){idx=(i+cards.length)%cards.length;var c=cards[idx];VV.src=c.dataset.src;VV.poster=c.dataset.poster;VA.textContent=c.dataset.author||'';VC.textContent=c.dataset.caption||'';VV.muted=muted;VV.load();var pp=VV.play();if(pp&&pp.catch)pp.catch(function(){VP.classList.add('paused');});VP.classList.remove('paused');}
  function openAt(i){openScrollY=window.scrollY;document.body.classList.add('sv-lock');document.body.style.top='-'+openScrollY+'px';VP.classList.add('open');buildProgress();loadIdx(i);if(rafId)cancelAnimationFrame(rafId);rafId=requestAnimationFrame(paintProgress);}
  function closePlayer(){VP.classList.remove('open');VV.pause();VV.removeAttribute('src');VV.load();document.body.classList.remove('sv-lock');document.body.style.top='';window.scrollTo(0,openScrollY);if(rafId)cancelAnimationFrame(rafId);}
  cards.forEach(function(c,i){c.addEventListener('click',function(){openAt(i);});});
  document.querySelectorAll('.gvcard').forEach(function(c){c.addEventListener('click',function(){var i=parseInt(c.dataset.idx||'0',10);openAt(i);});});
  $('vpNext').addEventListener('click',function(){loadIdx(idx+1);});
  $('vpPrev').addEventListener('click',function(){loadIdx(idx-1);});
  $('vpClose').addEventListener('click',closePlayer);
  VM.addEventListener('click',function(){muted=!muted;VV.muted=muted;VM.style.opacity=muted?'.55':'1';});
  VV.addEventListener('ended',function(){loadIdx(idx+1);});
  VV.addEventListener('click',function(){if(VV.paused){VV.play().catch(function(){});VP.classList.remove('paused');}else{VV.pause();VP.classList.add('paused');}});
  document.addEventListener('keydown',function(e){if(!VP.classList.contains('open'))return;if(e.key==='Escape')closePlayer();else if(e.key==='ArrowRight')loadIdx(idx+1);else if(e.key==='ArrowLeft')loadIdx(idx-1);});
  /* swipe on mobile */
  var sx=0;VP.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;});VP.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>60){if(dx<0)loadIdx(idx+1);else loadIdx(idx-1);}});
}

/* ---- scroll reveal ---- */
if(!window.matchMedia('(prefers-reduced-motion:reduce)').matches && 'IntersectionObserver' in window){
  var sel='.section h2,.section .lead,.persona,.rcard,.ritem,.feature .media,.ctable,.vcard,.giveback,.marquee';
  var els=document.querySelectorAll(sel);
  els.forEach(function(el){el.setAttribute('data-reveal','');});
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');io.unobserve(e.target);}});},{threshold:.08,rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(el){io.observe(el);});
  setTimeout(function(){els.forEach(function(el){if(!el.classList.contains('vis'))el.classList.add('vis');});},3000);
}
})();
